<script>
import {getPayFormFields} from "@/translate";
import {get_UPAYS_LIVE, get_UPAYS_TEST} from "@/components/hid";

export default {
  name: 'Preview',
  data() {
    return {
      entity : {
        email: null,
        name:null,
        address:null,
        vatid:null,
        regno:null,
        currency:'eur',
      },
      stripe: '',
      elements: '',
      card: null,
      entityFlag: false,
      stripeAPI:null,
      nmonths:1,
      baseURL:null,
      stripeClientTokenId:null,
      mailServerMsg:null,
      price_unit:34,
      b2b:0,
      monthly:0,
      lang:0,
      paymentLines:[
        'Created by','UpayS with Stripe','Name','Company Name','Registration Number','Address','Billing Address',
        'VAT Id','E-mail','Months','Currency',
        'By providing your Card Number and confirming this payment you are authorizing STRIPE - the payment service provider to send instructions to your bank to debit your account.',
        'Pay','Cancel','Invoice Required fields','Privacy Policy','The entered data is used to generate your invoice'
      ],
      payon:false,
    }
  },
  created() {
    this.emitter.on('change_language', (evt) => {
      //console.log(evt.eventContent)
      if(evt.eventContent === '1') {
        this.paymentLines = getPayFormFields(1)
      }else {
        this.paymentLines = getPayFormFields(0)
      }
    })
  },
  mounted() {
    window.scroll(0, 0);
    this.b2b = Number.parseInt(this.$route.params.p1)
    this.monthly = Number.parseInt(this.$route.params.p2)
    this.lang = Number.parseInt(this.$route.params.p3)
    this.paymentLines = getPayFormFields(this.lang)
    this.startPaymentBusinessClient()
  },
  computed: {
    isEuro() {
      return this.entity.currency ==='eur'
    },
    isUsd() {
      return this.entity.currency ==='usd'
    },
    isYen(){
      return this.entity.currency ==='cny'
    },
    payBtnStatus() {
      return !this.entityFlag
    },
    price() {
      return this.price_unit*this.nmonths
    },
    valability() {
      let now = new Date()
      /*
      let safaribw = false
      if(this.$store.getters.getExtendActive) {
          const stime = this.$store.getters.getCurrentBusiness.subscription_time
          const num_months = this.$store.getters.getCurrentBusiness.subscription_months
          now = new Date(stime)
          if(isNaN(now)) {
              // SAFARI case
              safaribw = true
              const darr = stime.split('-')
              now = new Date(darr[0],darr[1],darr[2])
          }
          now.setMonth(now.getMonth() + num_months);
      }*/
      now.setMonth((now.getMonth()+1) + this.nmonths);
      //return safaribw ? now.getFullYear() + '-' + now.getMonth() + '-' + now.getDate() : now.getFullYear() + '-' + (now.getMonth()+1) + '-' + now.getDate()
      return now.getFullYear() + '-' + now.getMonth() + '-' + now.getDate()
    },
    payOn(){
      return this.payon;
    },
    b2B() {
      return this.b2b === 0;
    },
    isMonthly() {
      return this.monthly !== 0;
    },
  },
  methods: {
    previewAction() {
      alert("Simulated Payment...")
      localStorage.removeItem('card_data')
      localStorage.removeItem('invoice_data')
    },
    cancelpayment() {
      localStorage.removeItem('preview_ups')
      let back_route = localStorage.getItem('back_route')
      //this.$router.go(-1)
      localStorage.removeItem('back_route')
      this.$router.push(back_route)

    },
    configClientStripe() {
      this.stripe = window.Stripe(this.stripeAPI)
      this.elements = this.stripe.elements()
      this.card = this.elements.create('card')
      this.card.mount('#card-element')
      // Handle real-time validation errors from the card Element.
      this.card.addEventListener('change', function(event) {
        let displayError = document.getElementById('card-errors')
        let btnPlaystatus = document.getElementById('paybtn')
        if(event.complete){
          //alert("Complete data")
          const idata = localStorage.getItem('invoice_data')
          btnPlaystatus.disabled = !idata
          localStorage.setItem('card_data','1')
        } else{
          btnPlaystatus.disabled = true
          localStorage.removeItem('card_data')
          if (event.error) {
            displayError.textContent = event.error.message
          }else{
            displayError.textContent = ''
          }
        }
      })
    },
    startPaymentBusinessClient() {
      this.stripeAPI = process.env.NODE_ENV === 'development' ? get_UPAYS_TEST() : get_UPAYS_LIVE()
      this.configClientStripe()
    },
    checkEmailFormat() {
      if(!this.entity.email) {
        //console.log('Check email null')
        return false
      }else {
        //console.log('Check email not null')
        const eform = this.entity.email.toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            )
        return eform
      }
    },
    checkEntity() {
      const card_data = localStorage.getItem('card_data')
      if(!this.entity.address || !this.entity.name || !this.entity.vatid ||
          !this.entity.regno || (this.nmonths < 1) || !this.checkEmailFormat()) {
        this.entityFlag = false
        localStorage.removeItem('invoice_data')
      }else{
        this.entityFlag = card_data
        localStorage.setItem('invoice_data','1')
      }
    }
  }
}
</script>
<template>
  <br>
  <div class="stripe-container">
    <div class="acenter">
            <span style="margin-left: 5px">
                {{ paymentLines[0] }}
                <a href="https://stripe.com/en-ro"  target="_blank" style="font-size: 12px;color: lightpink;">
                    {{ paymentLines[1] }}
                </a>
            </span>
      <br><br>
      <span class="icon-container">
            <img src="../assets/stripe-badge-grey.png" width="60%" height="60%">
          </span>
    </div>
    <div class="col-75">
      <form method="post"  @submit.prevent="previewAction" id="payment-form">
        <div class="row">
          <div class="col-25">
            <label for="entity" class="required">{{paymentLines[2]}}</label> &nbsp;
            <input id="entity" name="entity" type="text" :placeholder="paymentLines[3]" v-model="entity.name" @keyup="checkEntity" required>
          </div>
          <div class="col-25">
            <label for="address" class="required">{{ paymentLines[5] }}</label>
            <input id="address" name="entity" type="text" :placeholder="paymentLines[6]" v-model="entity.address"  @keyup="checkEntity" required>
          </div>
        </div>
        <div class="row">
          <div v-show="b2B" class="col-25">
            <label for="regno" class="required">{{ paymentLines[4] }}</label>
            <input  id="regno" name="regno" type="business" placeholder="J22/842/2024" v-model="entity.regno" @keyup="checkEntity" required/>
          </div>
          <div v-show="b2B" class="col-25">
            <label for="vatid" class="required" >{{ paymentLines[7] }}</label>
            <input id="vatid" name="vatid" type="business" placeholder="RO12345678" v-model="entity.vatid" @keyup="checkEntity" required/>
          </div>
        </div>
        <div class="row">
          <div class="col-25">
            <label for="emailconfirm" class="required">{{ paymentLines[8] }}</label> &nbsp;
            <input id="emailconfirm" name="email" type="email" placeholder="name@server.domain" v-model="entity.email" @keyup="checkEntity" required>
          </div>
          <div class="col-25">
            <label for="months"><span style="font-size: 12px;margin-right: 5px;font-weight: bold">{{ paymentLines[9] }}</span></label>&nbsp;&nbsp;
            <input :disabled="isMonthly" type="number" id="months"  min="1" max="12" v-model="nmonths"  @change="checkEntity" @keyup="checkEntity">
            <span class="valability">
              {{valability}}
            </span>
            <i class="fa fa-calendar-check-o" style="float: right;margin-right: 10px"></i>
          </div>
        </div>
        <label for="card-element">
        </label>
        <br>
        <div class="row">
          <div class="col-25">
            <div id="card-element">
              <!-- A Stripe Element will be inserted here. -->
            </div>
            <!-- Used to display form errors. -->
            <div id="card-errors" role="alert"></div>
            <div class="bankmsg">
              {{paymentLines[11]}}
            </div>
          </div>
          <div class="col-25">
            <label for="currency" class="required">{{ paymentLines[10] }}</label>
            <select id="currency" v-model="entity.currency" style="float: right">
              <option value="eur">Euro</option>
              <option value="usd">Usd</option>
              <option value="cny">Yuan</option>
            </select>
          </div>
        </div>
        <br>
        <hr>
        <div class="col-50">
          <span v-if="!payOn">
            <button :disabled="payBtnStatus" class="btn" id="paybtn">
                      {{ paymentLines[12] }}
                        <span>
                            {{price}}
                        </span>&nbsp;
                      <i v-show="isEuro" class="fa fa-eur" aria-hidden="true"></i>
                      <i v-show="isUsd" class="fa fa-usd" aria-hidden="true"></i>
                      <i v-show="isYen" class="fa fa-jpy" aria-hidden="true"></i>
                    </button>
            <button class="btncancel" @click.prevent="cancelpayment()">{{ paymentLines[13] }}</button>
          </span>
          <span v-else>
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size: 18px"></i>
            <span style="color: #fa755a">Payment ongoing</span>
          </span>
        </div>
        <div>
          <span style="font-size: 11px;float:left">* {{ paymentLines[14] }} </span>
        </div>
      </form>
    </div>
    <br>
    <div class="privacymsg">
      <span style="color: yellow"><i class="fa fa-shield" aria-hidden="true" ></i> {{ paymentLines[15] }}</span>
      {{ paymentLines[16] }}
    </div>
  </div>
</template>
<style scoped>
.required:after {
  content:" *";
  color: lightpink;
}
.stripe-container {
  padding: 20px 20px;
  max-width: 100%;
  margin:20px 100px;
  background-color: black;
  color: white;
  border-radius: 10px;
}

input,
.StripeElement {
  box-sizing: border-box;
  height: auto;
  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
  padding: 8px 8px;
}

input:focus,
.StripeElement--focus {
  box-shadow: 0 1px 3px 0 black;
  color: black;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

.row {
  display: -ms-flexbox; /* IE10 */
  display: flex;
  -ms-flex-wrap: wrap; /* IE10 */
  flex-wrap: wrap;
  margin: 0 -16px;
}
.acenter {
  padding: 10px;
  width: 60%;
  height: 60%;
  /*margin-left: 20%;*/
  display: inline-block;
  margin-bottom: 20px;
}
.col-25 {
  -ms-flex: 35%; /* IE10 */
  flex: 35%;
}
.col-50 {
  -ms-flex: 50%; /* IE10 */
  flex: 50%;
}
.col-75 {
  -ms-flex: 75%; /* IE10 */
  flex: 75%;
}
.col-25,
.col-50,
.col-75 {
  padding: 0 16px;
}
label {
  margin-bottom: 10px;
  display: block;
  font-size: 13px;
  text-align: left;
  clear: both;
  float:left;
  font-weight: bold;
}
input[type=text] {
  width: 45vh;
  height: 5px;
  margin-bottom: 15px;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color: white;
  float:right;

}
input[type=email] {
  width: 30vh;
  height: 10px;
  margin-bottom: 15px;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color: white;
  float:right;
}
input[type=business] {
  width: 20vh;
  height: 20px;
  margin-bottom: 25px;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color: white;
  float:right;
}
input[type=number] {
  width: 10vh;
  height: 20px;
  margin-bottom: 25px;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color: white;
  margin-left: 5px;
  float: right;
}
.icon-container {
  padding: 7px 0;
}
.btn {
  background-color: lightgreen;
  color: black;
  padding: 10px;
  margin: 10px 0;
  border: none;
  width: 28vh;
  border-radius: 3px;
  cursor: pointer;
  font-size: 15px;
}
.btn:hover {
  background-color: limegreen;
}
.btn:disabled {
  background-color: #aaaaaa;
}
.btncancel {
  background-color: darkred;
  color: white;
  padding: 10px;
  margin: 10px 10px 10px 10px;
  border: none;
  width: 28vh;
  border-radius: 3px;
  cursor: pointer;
  font-size: 15px;
}
.btncancel:hover {
  background-color: crimson;
}
a {
  color: #ffffff;
}

hr {
  border: 1px solid lightgrey;
}
.bankmsg {
  font-style: italic;
  font-size: 12px;
  margin-top: 5px;
}

/* Mark input boxes that gets an error on validation: */
input.invalid {
  background-color: #ffdddd;
}
.valability {
  font-size: 14px;
  font-weight: bold;
  color: darkblue;
  background-color: lightgreen;
  padding: 5px 5px;
  float: right;
}
.privacymsg {
  font-size: 12px;
  padding-top: 10px;
  text-align: center
}
select {
  padding: 5px 5px;
  float: left;
  margin-left: 15%;
}
/* Responsive layout - when the screen is less than 430px wide,
   make the two columns stack on top of each other instead of next to each other
*/
@media (max-width: 1150px) {
  .stripe-container {
    margin: 0px;
    width: 92%;
  }
  .row {
    flex-direction: column-reverse;
  }
  .col-25 {
    margin-bottom: 20px;
  }
  button {
    font-size: 10px;
  }
  input[type=text],input[type=email],input[type=business] {
    height: 0px;
    font-size: 12px;
    width: 100%;
  }
  .icon-container {
    font-size: 10px;
  }
  .bankmsg {
    font-size: 8px;
  }
  .btn {
    font-size: 10px;
    width: 11vh;
  }
  .btncancel {
    font-size: 10px;
    width:11vh;
  }
  .privacymsg {
    font-size: 8px;
  }
  .acenter {
    width: auto;
    height: auto;
  }
  span {
    font-size: 10px;
  }
}
</style>